module.exports = __webpack_public_path__ + "img/classic3.52ddf512.png";